import { instrumentsDisponibles } from "../sessionManager";
import { useState, useRef } from "react";
import { sample } from "$utils/math";
import { getAppVersionInfo, getProjectDataObject } from "$utils/misc";
import { capitalize } from "$utils/string"
import { ProjectLikeFrame } from "./Connect"
import { makeUID } from "../utils/math";
import store, { addInstrument } from "../store";

const paraules = {
    "Mestre": { type: "name_prefix", gender: "masculine", number: "singular" },
    "Mestressa": { type: "name_prefix", gender: "feminine", number: "singular" },
    "Sr.": { type: "name_prefix", gender: "masculine", number: "singular" },
    "Sra.": { type: "name_prefix", gender: "feminine", number: "singular" },
    "Professor": { type: "name_prefix", gender: "masculine", number: "singular" },
    "Professora": { type: "name_prefix", gender: "feminine", number: "singular" },
    "Príncep": { type: "name_prefix", gender: "masculine", number: "singular" },
    "Princesa": { type: "name_prefix", gender: "feminine", number: "singular" },
    "El del Poble": { type: "name_prefix", gender: "masculine", number: "singular" },
    "La del Poble": { type: "name_prefix", gender: "feminine", number: "singular" },
    "Bella": { type: "name_prefix", gender: "feminine", number: "singular" },
    "Lord": { type: "name_prefix", gender: "masculine", number: "singular" },
    "Lady": { type: "name_prefix", gender: "feminine", number: "singular" },
    "L'estimat": { type: "name_prefix", gender: "masculine", number: "singular" },
    "L'estimada": { type: "name_prefix", gender: "feminine", number: "singular" },
    "cristall": { type: "noun", gender: "masculine", plural: "cristalls" },
    "somni": { type: "noun", gender: "masculine", plural: "somnis" },
    "corneta": { type: "noun", gender: "feminine", plural: "cornetes" },
    "lluna": { type: "noun", gender: "feminine", plural: "llunes" },
    "tronc": { type: "noun", gender: "masculine", plural: "troncs" },
    "braç": { type: "noun", gender: "masculine", plural: "braços" },
    "peu gran": { type: "noun", gender: "masculine", plural: "peus grans" },
    "forat": { type: "noun", gender: "masculine", plural: "forats" },
    "creador de somnis": { type: "noun", gender: "masculine", plural: "creadors de somnis" },
    "creadora de somnis": { type: "noun", gender: "feminine", plural: "creadores de somnis" },
    "castell": { type: "noun", gender: "masculine", plural: "castells" },
    "molsa": { type: "noun", gender: "feminine", plural: "molses" },
    "flor": { type: "noun", gender: "feminine", plural: "flors" },
    "muntanya": { type: "noun", gender: "feminine", plural: "muntanyes" },
    "història": { type: "noun", gender: "feminine", plural: "històries" },
    "pluja": { type: "noun", gender: "feminine", plural: "plujes" },
    "boira": { type: "noun", gender: "feminine", plural: "boires" },
    "tempesta": { type: "noun", gender: "feminine", plural: "tempestes" },
    "cor": { type: "noun", gender: "masculine", plural: "cors" },
    "gos": { type: "noun", gender: "masculine", plural: "gossos" },
    "cançó": { type: "noun", gender: "feminine", plural: "cançons" },
    "pedra": { type: "noun", gender: "feminine", plural: "pedres" },
    "perdut": { type: "adjective", gender: "masculine", plural: "perduts" },
    "perduda": { type: "adjective", gender: "feminine", plural: "perdudes" },
    "antic": { type: "adjective", gender: "masculine", plural: "antics" },
    "antigua": { type: "adjective", gender: "feminine", plural: "antigues" },
};

function sampleWordObjectByCriteria(criteria, objectCount=1) {
    const wordObjects = Object.entries(paraules)
    .filter(([singular, detalls]) => {
      return Object.entries(criteria).every(([criteri, valor]) => detalls[criteri] === valor);
    }).map(([singular, detalls]) => ({ ...detalls, singular }));

    return sample(wordObjects, objectCount);
}

function generateTitle() {
    const [primary_noun_object, secondary_noun_object] = sampleWordObjectByCriteria({ type: "noun" }, 2);

    const primary_noun = primary_noun_object.singular;
    const gender_primary = primary_noun_object.gender;

    const secondary_noun = secondary_noun_object.plural;
    const gender_secondary = secondary_noun_object.gender;

    const adjective = sampleWordObjectByCriteria({ type: "adjective", gender: gender_secondary }).plural;

    let title;
    const secondary_noun_determinant = gender_secondary === 'masculine' ? 'els' : 'les';
    if (Math.random() < 0.5) {
        const name_prefix = sampleWordObjectByCriteria({ type: "name_prefix", gender: gender_primary }).singular;
        title = [name_prefix, capitalize(primary_noun), 'i', secondary_noun_determinant, secondary_noun, adjective].join(" ");
    } else {
        const possessive_determinant = gender_primary === 'masculine' ? 'del' : 'de la';
        title = [capitalize(secondary_noun_determinant), secondary_noun, adjective, possessive_determinant, primary_noun].join(" ");
    }
    return title;
}

export const NewProject = () => {
    const defaultTitle = useRef(generateTitle());
    const openAfegeixModal = useRef(() => {});
    const instrumentsDefault = {
        synth_wam: 1,
        synth_bass_wam: 1,
        sampler: 1,
        piano_soundfont: 1,
        groovebox: 1,
        looper: 1,
    }

    const handleAfegeixModal = () => {
        openAfegeixModal.current();
    }

    const handleSubmitForm = (evt) => {
        const nameEl = document.querySelector('[name=name]');
        const name = nameEl.value !== '' ? nameEl.value : nameEl.placeholder; // donem el títol per defecte si no s'ha introduït
        
        Object.entries(instrumentsDefault).forEach(([tipus, quantity]) => {
            for (let i = 0; i < quantity; i++) {
                id = makeUID(tipus);
                const data = instrumentsDisponibles[tipus].createInitialStateObject();
                store.dispatch(addInstrument({id, data}));
            }
        });


        const projectData = getProjectDataObject();
        Object.assign(projectData, {
            metadata: {
                name,
                creation_timestamp: new Date().getTime(),
                version_info: getAppVersionInfo(),
                token: Math.random().toString(36).substring(2, 15),
            },
        });
        
        const form = document.querySelector('form');
        const data = document.createElement('input');
        data.setAttribute('type', 'hidden');
        data.name = 'data'
        data.value = JSON.stringify(projectData);
        form.appendChild(data);
        form.submit();
    }

    return <ProjectLikeFrame content={
        <form className="new-project-wrapper" method="POST" action=".">
            <div className="project-header">
                <h1>Crea un nou GRUF</h1>
                <div className="input-title">
                    Títol: <input name="name" placeholder={defaultTitle.current} autoComplete="false" />
                </div>
            </div>
            <div className="notificacio-controls">
                    Al crear el GRUF, envia un correu amb les dades del GRUF a la següent adreça de correu electrònic (opcional):
                    <input
                        name="email"
                        placeholder="correu@electronic.cat"
                    />
                </div>
            <div className="footer-controls">
                <button type="button" className="btn btn-gran btn-black--primary" onClick={handleSubmitForm}>Crear el GRUF!</button>
            </div>
        </form>
    }/>
};
